// 赠送相关，而又不是在show页面展示的路由
import {loadPageFail} from '../lib/units';

export default [
    {
        name: 'giftReceive',
        path: '/giftReceive/:channelId/:receiveKey',
        meta: {
            title: '赠礼赠送页'
        },
        component: resolve => require(['../pages/show/gift/giftReceive.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '赠礼赠送页',
                err
            });
        })
    },
    {
        name: 'giftSuccess',
        path: '/payGift/success',
        meta: {
            title: '赠礼支付成功'
        },
        component: resolve => require(['../pages/show/gift/giftSuccess.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '赠礼支付成功页',
                err
            });
        })
    },
    {
        name: 'goShareGift',
        path: '/giftShare/:channelId/:receiveKey',
        meta:{
            title: '赠礼分享页',

        },
        component: resolve => require(['../pages/show/gift/giftShare.vue'], resolve, (err)=>{
            loadPageFail({
                pagename: '赠礼分享页',
                err
            });
        })
    }
]



// WEBPACK FOOTER //
// ./src/router/gift.js